/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, Jan 2022
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import SlotHeader from './SlotHeader';
import SlotFooter from './SlotFooter';
import SlotContent from './SlotContent';
import classes from './Slot.module.css';
import FireboardUtils from '../../../../util/fireboard-util';
import { TimeConstants } from '../../../../constants';

const Slot = props => {
  const { showPopup, onSlotActionButtonPress, slot, deviceGroup, onSlotAssign, onShowCheckDetails } = props;
  const check = slot?.checkData || {};
  const { slotBorderColor, slotElapsedTimeInMS } = check || {};
  let occupied = !FireboardUtils.isObjectBlank(check);
  if (slotElapsedTimeInMS && deviceGroup && !FireboardUtils.isObjectBlank(deviceGroup)) {
    const { orderUpClearTime } = deviceGroup || {}; //time is in seconds
    const orderUpClearTimeInMS = orderUpClearTime ? orderUpClearTime * TimeConstants.SECOND : 0;
    if (orderUpClearTimeInMS && slotElapsedTimeInMS > orderUpClearTimeInMS)
      occupied = false;
  }

  return (
    <div className={classes.container} style={{ borderColor: slotBorderColor || 'white' }}>
      <SlotHeader
        occupied={occupied}
        showPopup={showPopup}
        slot={slot}
        onShowCheckDetails={onShowCheckDetails}
      />
      {occupied
        ? <SlotContent check={check} />
        : <UnoccupiedSlotContent onSlotAssign={onSlotAssign} slot={slot} />
      }
      {occupied && (
        <SlotFooter
          onSlotActionButtonPress={onSlotActionButtonPress}
          slot={slot}
        />
      )}
    </div>
  );
};

export default Slot;

Slot.propTypes = {
  slot: PropTypes.object,
  showPopup: PropTypes.func,
  onSlotActionButtonPress: PropTypes.func,
  deviceGroup: PropTypes.object,
  onSlotAssign: PropTypes.func,
  onShowCheckDetails: PropTypes.func,
};

Slot.defaultProps = {
  slot: {},
  showPopup: () => { },
  onCubbyActionButtonPress: () => { },
  deviceGroup: null,
  onSlotAssign: () => { },
  onShowCheckDetails: () => { },
};

const UnoccupiedSlotContent = ({ slot, onSlotAssign }) => {
  return (
    <div className={classes.unOccupiedWrapper} onClick={() => onSlotAssign(slot)}>
      <span className={classes.plus}>+</span>
    </div>
  );
};
